import React, { FC } from 'react';
import s from './accordionItem.module.scss';
import { SpriteIcon } from '@components/Sprites/SpriteIcon';
import cn from 'classnames';
interface Props {
  children: React.ReactNode;
  onClick: () => void;
  isOpen: boolean;
  isDisabled?: boolean;
}
export const Header: FC<Props> = ({
  children,
  onClick,
  isOpen,
  isDisabled
}) => {
  return <div className={cn(s.accordionItemHeader, isDisabled && s.accordionItemHeader_disabled)} onClick={() => {
    if (isDisabled) return;
    onClick();
  }} data-sentry-component="Header" data-sentry-source-file="Header.tsx">
            <div className={cn(s.accordionItemHeader__title, isDisabled && s.accordionItemHeader__title_disabled)}>
                {children}
            </div>
            <SpriteIcon className={s.accordionItemHeader__icon} name={isOpen ? 'minus' : 'plus'} width={20} height={20} data-sentry-element="SpriteIcon" data-sentry-source-file="Header.tsx" />
        </div>;
};